export default "__VITE_ASSET__D2t9CXOc__"